import { render } from "./TdTile.vue?vue&type=template&id=fb6c56d4&scoped=true"
import script from "./TdTile.vue?vue&type=script&lang=js"
export * from "./TdTile.vue?vue&type=script&lang=js"

import "./TdTile.vue?vue&type=style&index=0&id=fb6c56d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6c56d4"]])

export default __exports__